/**
 * @ngdoc controller
 * @name LogoutController
 * @description
 * This is the component controller for the `logout` component.
 *
 * @memberof account
 * @requires common
 */
class LogoutController {
  /**
   * Class constructor.
   * @param {Object}  $rootScope   To broadcast the authorization events.
   * @param {Service} $window      To redirect the user when the logout process finishes.
   * @param {Object}  AUTH_EVENTS  To get the name of the event to be broadcasted.
   * @ignore
   */
  constructor(
    $rootScope,
    $window,
    AUTH_EVENTS,
  ) {
    'ngInject';

    /**
     * The local reference to the `$rootScope` object.
     * @type {Object}
     */
    this.$rootScope = $rootScope;
    /**
     * The local reference to the `$window` service.
     * @type {Object}
     */
    this.$window = $window;
    /**
     * The local reference to the `AUTH_EVENTS` constant.
     * @type {Object}
     */
    this.AUTH_EVENTS = AUTH_EVENTS;
  }
  /**
   * When this component gets mounted broadcast the logoutSuccess event
   * and redirect to `/login`.
   */
  $onInit() {
    this.$rootScope.$broadcast(this.AUTH_EVENTS.logoutSuccess);

    // Cache busting magic
    const timestamp = (new Date()).getTime();
    this.$window.location.href = this.updated === 'true'
      ? `/login?t=${timestamp}&updated=true`
      : `/login?t=${timestamp}`;
  }
}

export default LogoutController;



// WEBPACK FOOTER //
// ./src/frontend/modules/account/components/logout/logout.controller.js